import React from "react";

import { withRouter } from "../util/liexRouter";
import { genericPost } from "../util/dataLoader";
import {
  API_GET_DATA_FOR_PASS_RESET_URL,
  API_BASE_URL,
  API_UPDATE_PASS_URL,
} from "../api/liex";
import appg from "../appg";
import liex from "../api/liex";

class ResetPass extends React.Component {
  state = {
    password: "",
    passwordConfirm: "",
    email: "",
    fullname: "",
    smscode: "",
    server_code: "",
    error: "",
  };

  componentDidMount() {
    if (!this.props.router.params.token) {
      this.setState({ error: "Token no encontrado" });
    } else {
      let token = this.props.router.params.token;
      genericPost(
        API_BASE_URL + API_GET_DATA_FOR_PASS_RESET_URL,
        "No es posible solicitar informacion para restablecer contraseña.",
        { token: token },
        (data) => {
          this.setState({
            email: data.email,
            fullname: data.fullname,
            server_code: data.sms_code,
          });
          //   console.log(this.state);
        }
      );
    }
  }

  onSubmit = (event) => {
    event.preventDefault();
  };

  onSubmitClick = async (event) => {
    event.preventDefault();
    // console.log(this.state);

    if (this.state.password === "" || this.state.smscode === "") {
      this.setState({ error: "Debe completar todos los campos." });
      return;
    }

    if (this.state.password !== this.state.passwordConfirm) {
      this.setState({ error: "Las contraseñas no coinciden" });
      return;
    }
    if (this.state.smscode !== this.state.server_code) {
      this.setState({
        error: "El código SMS no coincide con el que se envio a su telefono",
      });
      return;
    }
    if (this.state.password.length < 8) {
      this.setState({
        error: "La contraseña debe tener al menos 8 caracteres",
      });
      return;
    }

    let token = this.props.router.params.token;
    let payload = {
      token: token,
      password: this.state.password,
      smscode: this.state.smscode,
    };
    // console.log(payload);

    try {
      const res = await liex.post(API_BASE_URL + API_UPDATE_PASS_URL, payload);
      appg.toast.show({
        severity: "success",
        summary: "Contraseña cambiada",
        detail: res.data.message + " Ya puede cerrar esta ventana.",
      });
    } catch (error) {
      if (error.response.data) {
        appg.toast.show({
          severity: "error",
          summary: "Error al actualizar contraseña",
          detail: error.response.data.message,
        });
      }
    }
    this.setState({ error: "" });
  };

  messageClass = () => {
    return this.state.error
      ? "ui alert alert-danger"
      : "ui alert alert-success";
  };

  renderMessage = (isError) => {
    if (this.state.error) {
      return (
        <div
          className={this.messageClass()}
          style={{ marginTop: 20 }}
          role="alert"
        >
          <h3>{this.state.error}</h3>
        </div>
      );
    }
  };

  render() {
    return (
      <div className="ui container">
        <h1>Restablecer contraseña</h1>
        <div className="ui form">
          <div className="field">
            <label>Usuario</label>
            <input
              type="text"
              defaultValue={this.state.fullname}
              disabled={true}
            />
          </div>
          <div className="field">
            <label>Correo</label>
            <input
              type="text"
              defaultValue={this.state.email}
              disabled={true}
            />
          </div>
        </div>
        <div className="ui divider"> </div>
        <form className="ui form" onSubmit={this.onSubmit}>
          <div className="field">
            <label>Contraseña</label>
            <input
              type="password"
              name="password"
              placeholder="contraseña"
              value={this.state.password}
              onChange={(e) => this.setState({ password: e.target.value })}
              autoFocus={true}
            />
          </div>
          <div className="field">
            <label>Confirmar contraseña</label>
            <input
              type="password"
              name="password2"
              placeholder="confirmar contraseña"
              value={this.state.passwordConfirm}
              onChange={(e) =>
                this.setState({ passwordConfirm: e.target.value })
              }
            />
          </div>
          <div className="field">
            <label>Código SMS</label>
            <input
              type="text"
              name="smscode"
              placeholder="sms"
              value={this.state.smscode}
              onChange={(e) => this.setState({ smscode: e.target.value })}
            />
          </div>
          <button
            className="ui button"
            type="submit"
            onClick={this.onSubmitClick}
          >
            Restablecer
          </button>
        </form>
        {this.renderMessage()}
      </div>
    );
  }
}

export default withRouter(ResetPass);
